// extracted by mini-css-extract-plugin
module.exports = {"white":"markdown-beautiful_white_ijk0y","small":"markdown-beautiful_small_1Vttw","big":"markdown-beautiful_big_QpFkP"};